import React from "react";
import Style from "./SchoolBuildingGlobal.module.css";

interface LearningExperience {
  id: number;
  title: string;
  description: string;
}

interface UgpgBusinessMindProps {
  data: LearningExperience[];
  isUgpg?: boolean;
}

const SchoolBuildingGlobal: React.FC<UgpgBusinessMindProps> = ({
  data,
  isUgpg,
}: any) => {
  return (
    <div className={isUgpg ? Style.ugpgGlobalRow : Style.schoolGlobalRow}>
      <div className="container">
        <h2>{data?.title}</h2>

        <div className="row">
          <>
            {data?.cards.map((item: any) => (
              <div className={`col-md-4 ${Style.rowSpaceBottom}`} key={item.id}>
                <div className={Style.schoolGlobalContent}>
                  <div
                    className={isUgpg ? Style.borderBlack : Style.borderYellow}
                  ></div>
                  <strong>{item.title}</strong>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </>
        </div>
      </div>
    </div>
  );
};

export default SchoolBuildingGlobal;
